import React from 'react';
import { MdClose, MdKeyboard } from 'react-icons/md';

export const KeyboardHelpModal = ({ showKeyboardHelp, setShowKeyboardHelp }) => {
  if (!showKeyboardHelp) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
      <div className="keyboard-help bg-white/95 backdrop-blur-sm rounded-2xl border border-white/40 shadow-2xl shadow-blue-500/20 max-w-2xl w-full mx-auto">
        <div className="p-6 border-b border-white/20">
          <div className="flex items-center justify-between">
            <h3 className="text-xl font-bold text-gray-800 flex items-center gap-3">
              <MdKeyboard className="text-blue-500 text-2xl" />
              Keyboard Shortcuts
            </h3>
            <button
              onClick={() => setShowKeyboardHelp(false)}
              className="p-2 hover:bg-white/60 rounded-xl transition-all duration-200"
            >
              <MdClose className="text-gray-600 text-xl" />
            </button>
          </div>
        </div>
        
        <div className="p-6 space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-4">
              <h4 className="font-semibold text-gray-700 text-sm uppercase tracking-wide border-b border-gray-200 pb-2">Navigation</h4>
              <div className="space-y-3">
                <div className="flex items-center justify-between">
                  <span className="text-gray-600">Previous Sentence</span>
                  <div className="flex gap-1">
                    <kbd className="px-2 py-1 bg-gray-100 border border-gray-300 rounded text-sm font-mono">←</kbd>
                    <kbd className="px-2 py-1 bg-gray-100 border border-gray-300 rounded text-sm font-mono">A</kbd>
                  </div>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-gray-600">Next Sentence</span>
                  <div className="flex gap-1">
                    <kbd className="px-2 py-1 bg-gray-100 border border-gray-300 rounded text-sm font-mono">→</kbd>
                    <kbd className="px-2 py-1 bg-gray-100 border border-gray-300 rounded text-sm font-mono">D</kbd>
                  </div>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-gray-600">Play/Pause Sentence</span>
                  <kbd className="px-3 py-1 bg-gray-100 border border-gray-300 rounded text-sm font-mono">Space</kbd>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-gray-600">Switch Mode</span>
                  <kbd className="px-2 py-1 bg-gray-100 border border-gray-300 rounded text-sm font-mono">T</kbd>
                </div>
              </div>
            </div>
            
            <div className="space-y-4">
              <h4 className="font-semibold text-gray-700 text-sm uppercase tracking-wide border-b border-gray-200 pb-2">Recording</h4>
              <div className="space-y-3">
                <div className="flex items-center justify-between">
                  <span className="text-gray-600">Start Recording</span>
                  <kbd className="px-2 py-1 bg-gray-100 border border-gray-300 rounded text-sm font-mono">R</kbd>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-gray-600">Stop Recording</span>
                  <kbd className="px-2 py-1 bg-gray-100 border border-gray-300 rounded text-sm font-mono">S</kbd>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-gray-600">Playback Recording</span>
                  <kbd className="px-2 py-1 bg-gray-100 border border-gray-300 rounded text-sm font-mono">P</kbd>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-gray-600">Stop Everything</span>
                  <kbd className="px-2 py-1 bg-gray-100 border border-gray-300 rounded text-sm font-mono">Esc</kbd>
                </div>
              </div>
            </div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-4">
              <h4 className="font-semibold text-gray-700 text-sm uppercase tracking-wide border-b border-gray-200 pb-2">Playback Speed</h4>
              <div className="grid grid-cols-3 gap-3">
                <div className="flex flex-col items-center text-center">
                  <kbd className="px-3 py-2 bg-gray-100 border border-gray-300 rounded-lg text-sm font-mono mb-2 w-12">1</kbd>
                  <span className="text-xs text-gray-500">Normal</span>
                </div>
                <div className="flex flex-col items-center text-center">
                  <kbd className="px-3 py-2 bg-gray-100 border border-gray-300 rounded-lg text-sm font-mono mb-2 w-12">2</kbd>
                  <span className="text-xs text-gray-500">Slow</span>
                </div>
                <div className="flex flex-col items-center text-center">
                  <kbd className="px-3 py-2 bg-gray-100 border border-gray-300 rounded-lg text-sm font-mono mb-2 w-12">3</kbd>
                  <span className="text-xs text-gray-500">Slowest</span>
                </div>
              </div>
            </div>
            
            <div className="space-y-4">
              <h4 className="font-semibold text-gray-700 text-sm uppercase tracking-wide border-b border-gray-200 pb-2">Visualization</h4>
              <div className="space-y-3">
                <div className="flex items-center justify-between">
                  <span className="text-gray-600">Toggle Visualization</span>
                  <kbd className="px-2 py-1 bg-gray-100 border border-gray-300 rounded text-sm font-mono">M</kbd>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-gray-600">Cycle Views</span>
                  <kbd className="px-2 py-1 bg-gray-100 border border-gray-300 rounded text-sm font-mono">V</kbd>
                </div>
              </div>
            </div>
          </div>
          
          <div className="pt-4 border-t border-white/20">
            <div className="flex items-center justify-between">
              <span className="text-gray-600">Show/Hide This Help</span>
              <kbd className="px-2 py-1 bg-gray-100 border border-gray-300 rounded text-sm font-mono">?</kbd>
            </div>
          </div>
        </div>
        
        <div className="p-4 bg-gray-50/50 rounded-b-2xl border-t border-white/20">
          <button
            onClick={() => setShowKeyboardHelp(false)}
            className="w-full py-3 bg-gradient-to-r from-blue-500 to-indigo-500 text-white rounded-xl font-medium transition-all duration-300 hover:from-blue-600 hover:to-indigo-600 shadow-lg shadow-blue-500/25"
          >
            Got it! Press ? to show again
          </button>
        </div>
      </div>
    </div>
  );
};